import { useState } from "react";

const useFiltersAndSearchMobile = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);

  return {
    openFilter,
    setOpenFilter,
    openSearch,
    setOpenSearch,
  };
};

export default useFiltersAndSearchMobile;
